import React from 'react'
import {
  CCard,
  CCardHeader,
  CCardBody,
  CFormLabel,
  CRow,
  CFormInput,
  CCol,
} from '@coreui/react-pro'

const GameSpot = (props) => {
  const field = (
    <CRow>
      <CCol md={12}>
        <CFormLabel htmlFor="user_number" className="fw-bold">
          Set Limit *
        </CFormLabel>
        <CFormInput
          min={1}
          type="number"
          id="user_number"
          value={props.value}
          onChange={(event) => props.onChange(event.target.value)}
          name="user_number"
        />
      </CCol>
    </CRow>
  )

  if (props.bare) {
    return field
  }

  return (
    <CCard className="mb-3">
      <CCardHeader>
        <strong>Game Spots Allowed</strong>
      </CCardHeader>
      <CCardBody>{field}</CCardBody>
    </CCard>
  )
}

export default GameSpot
